import { Card, Col, FormGroup, InputGroup, Row } from 'reactstrap';
import Subtitle from 'views/components/Subtitle';
import { TextField } from '@material-ui/core';
import { useEffect, useState } from 'react';
import formatCurrency from 'utils/formatCurrency';
import { iAcessoPrograma, iPropostaDados } from '../..';
import './style.css';
import SelecaoArredondamento from '../SelecaoArredondamento';

export default function Desconto({
  propostaVersao,
  isModoSimulacao,
  onChange,
  acessoPrograma,
}: {
  propostaVersao: iPropostaDados;
  isModoSimulacao: boolean;
  acessoPrograma: iAcessoPrograma;
  onChange: (a: iPropostaDados) => void;
}): JSX.Element {
  // No caso de desconto aprovado, ainda permite mudança.
  const bloquearGeral = !isModoSimulacao;

  const [metaValorTemp, setMetaValorTemp] = useState(
    formatCurrency(propostaVersao.metas.metaValor ?? 0, 2, false, false),
  );

  const [isAtingirMetaOuDesconto, setIsAtingirMetaOuDesconto] = useState(
    propostaVersao.metas.tipoMeta === 'V',
  );

  const handleTipoChange = (
    newTipo: 'D' | 'V' | null,
    event?: React.MouseEvent<HTMLElement>,
  ) => {
    if (newTipo !== null)
      onChange({
        ...propostaVersao,
        metas: {
          ...propostaVersao.metas,
          tipoMeta: newTipo,
        },
      });
  };

  useEffect(() => {
    setMetaValorTemp(
      formatCurrency(
        propostaVersao.valores.valorFinalComOutros ?? 0,
        2,
        false,
        false,
      ),
    );
  }, [propostaVersao.valores.valorFinalComOutros]);

  return (
    <Card className="shadow p-3">
      <Subtitle name="Atingir meta de desconto e valor" />
      <Row className="px-2 flex justify-center justify-content-center p-2 d-flex align-items-center">
        <Col sm="8">
          <FormGroup className="">
            <InputGroup className="input-group-alternative justify-content-center p-2 d-flex align-items-center">
              <TextField
                type="number"
                className={`${
                  (isAtingirMetaOuDesconto ||
                    propostaVersao.metas.tipoMeta !== 'D' ||
                    bloquearGeral) &&
                  'campo-desativado'
                }`}
                value={propostaVersao.metas.metaDesconto ?? 0}
                onChange={e => {
                  onChange({
                    ...propostaVersao,
                    metas: {
                      ...propostaVersao.metas,
                      metaDesconto: Number(e.target.value),
                    },
                    aprovacao: {
                      ...propostaVersao.aprovacao,
                      descontoAprovado: false,
                    },
                  });
                }}
                disabled={
                  isAtingirMetaOuDesconto ||
                  propostaVersao.metas.tipoMeta !== 'D' ||
                  bloquearGeral
                }
              />
              <span
                className={`ml-2 ${
                  (isAtingirMetaOuDesconto ||
                    propostaVersao.metas.tipoMeta !== 'D' ||
                    bloquearGeral) &&
                  'campo-desativado'
                }`}
              >
                Desconto (%)
              </span>
              <label className="custom-toggle mr-2 ml-2">
                <input
                  type="checkbox"
                  checked={isAtingirMetaOuDesconto}
                  disabled={!isModoSimulacao}
                  onChange={e => {
                    const novoValorIsAtingirMetaOuDesconto =
                      !isAtingirMetaOuDesconto;
                    handleTipoChange(
                      novoValorIsAtingirMetaOuDesconto ? 'V' : 'D',
                    );
                    setIsAtingirMetaOuDesconto(prev => !prev);
                  }}
                />
                <span className="custom-toggle-slider rounded-circle" />
              </label>
              <span
                className={`mr-2 ${
                  (!isAtingirMetaOuDesconto ||
                    propostaVersao.metas.tipoMeta !== 'V' ||
                    bloquearGeral) &&
                  'campo-desativado'
                }`}
              >
                Valor (R$)
              </span>
              <TextField
                type="text"
                className={`${
                  (!isAtingirMetaOuDesconto ||
                    propostaVersao.metas.tipoMeta !== 'V' ||
                    bloquearGeral) &&
                  'campo-desativado'
                }`}
                value={metaValorTemp}
                onChange={e => {
                  const valor = e.target.value;
                  setMetaValorTemp(valor);

                  const valorNumerico = Number(
                    valor
                      .replace('R$', '')
                      .trim()
                      .replaceAll('.', '')
                      .replaceAll(',', '.'),
                  );

                  if (!Number.isNaN(valorNumerico)) {
                    onChange({
                      ...propostaVersao,
                      metas: {
                        ...propostaVersao.metas,
                        metaValor: valorNumerico,
                      },
                      aprovacao: {
                        ...propostaVersao.aprovacao,
                        descontoAprovado: false,
                      },
                    });
                  }
                }}
                onBlur={() => {
                  const valorNumerico = Number(
                    metaValorTemp
                      .replace('R$', '')
                      .trim()
                      .replaceAll('.', '')
                      .replaceAll(',', '.'),
                  );

                  const valorFormatado = formatCurrency(
                    valorNumerico ?? 0,
                    2,
                    false,
                    false,
                  );
                  setMetaValorTemp(valorFormatado);
                }}
                disabled={
                  !isAtingirMetaOuDesconto ||
                  propostaVersao.metas.tipoMeta !== 'V' ||
                  bloquearGeral
                }
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col sm="12">
          <small className="justify-content-center p-2 d-flex align-items-center">
            {propostaVersao.aprovacao.descontoAprovado
              ? 'Desconto aprovado.'
              : 'Se desconto estiver fora da alçada, será disparado fluxo de aprovação.'}
          </small>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col className="mt-4" md="3">
          <SelecaoArredondamento
            informacaoProposta={propostaVersao}
            isModoSimulacao={isModoSimulacao}
            onChange={onChange}
          />
        </Col>
      </Row>
    </Card>
  );
}
